export const RecordDot = () => {
  const isSapo = !!import.meta.env.VITE_IS_SAPO
  if (isSapo) return null
  return (
    <div className="record-dots dot-1">
      <span className="dot" />
    </div>
  )
}

export const RecordDots = () => {
  const isSapo = !!import.meta.env.VITE_IS_SAPO
  if (isSapo) return null
  return (
    <div className="record-dots dot-3">
      <span className="dot" />
      <span className="dot" />
      <span className="dot" />
    </div>
  )
}
